// The developer portal is Wonya Code. Keep this canonical URL explicit so a
// stale deployment environment cannot send users to the retired dev portal.
export const API_PORTAL_URL = "https://code.wonyasoft.com/";
export const WONYASOFT_SITE_URL =
  process.env.REACT_APP_SITE_URL || "https://wonyaso.com/";
export const WONYAPAY_APP_DOWNLOAD_PATH = "/appmobile";
export const WONYAPAY_SMART_DOWNLOAD_PATH = "/wonyapay";
export const MASOMO_SMART_DOWNLOAD_PATH = "/masomo";
export const WONYAPAY_IOS_STORE_URL =
  "https://apps.apple.com/cd/app/wonyapay/id6740532331?l=fr-FR";
export const WONYAPAY_ANDROID_PACKAGE_ID = "com.wonyasoft.wpay";
export const WONYAPAY_ANDROID_MARKET_URL = `market://details?id=${WONYAPAY_ANDROID_PACKAGE_ID}`;
export const WONYAPAY_ANDROID_STORE_URL = `https://play.google.com/store/apps/details?id=${WONYAPAY_ANDROID_PACKAGE_ID}`;
export const WONYAPAY_MACOS_STORE_URL =
  "https://apps.apple.com/cd/app/wonyapay/id6740532331?platform=mac";
export const WONYAPAY_WINDOWS_STORE_URL =
  "https://apps.microsoft.com/detail/9NQD5RPW131L?hl=neutral&gl=FR&ocid=pdpshare";
export const MASOMO_ANDROID_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.wonyasoft.masomo";
export const MASOMO_IOS_STORE_URL =
  "https://apps.apple.com/cd/app/masomo-mobile/id6816394937";
export const MASOMO_MACOS_STORE_URL =
  "https://apps.apple.com/cd/app/masomo/id6816385292?mt=12";
export const MASOMO_WINDOWS_STORE_URL =
  "https://apps.microsoft.com/detail/9PG055TPQTDT";

const getSmartDownloadUrl = (browserNavigator, stores) => {
  const userAgent = browserNavigator?.userAgent ?? "";
  const platform = browserNavigator?.platform ?? "";
  const reportedPlatform = browserNavigator?.userAgentData?.platform ?? "";
  const maxTouchPoints = browserNavigator?.maxTouchPoints ?? 0;

  // Windows Phone user agents can also contain Android and iPhone tokens.
  if (/Windows Phone|IEMobile/i.test(userAgent)) {
    return WONYAPAY_APP_DOWNLOAD_PATH;
  }

  if (/android/i.test(`${userAgent} ${reportedPlatform}`)) {
    return stores.android;
  }

  const isAppleMobile =
    /iPhone|iPad|iPod/i.test(userAgent) ||
    (/Mac/i.test(`${platform} ${userAgent}`) && maxTouchPoints > 1);

  if (isAppleMobile) {
    return stores.ios;
  }

  if (/Windows|Win32|Win64/i.test(`${userAgent} ${platform} ${reportedPlatform}`)) {
    return stores.windows;
  }

  if (/Mac/i.test(`${userAgent} ${platform} ${reportedPlatform}`)) {
    return stores.macos;
  }

  return WONYAPAY_APP_DOWNLOAD_PATH;
};

export const getWonyapaySmartDownloadUrl = (
  browserNavigator = typeof navigator === "undefined" ? undefined : navigator,
) => getSmartDownloadUrl(browserNavigator, {
  android: WONYAPAY_ANDROID_STORE_URL,
  ios: WONYAPAY_IOS_STORE_URL,
  macos: WONYAPAY_MACOS_STORE_URL,
  windows: WONYAPAY_WINDOWS_STORE_URL,
});

export const getMasomoSmartDownloadUrl = (
  browserNavigator = typeof navigator === "undefined" ? undefined : navigator,
) => getSmartDownloadUrl(browserNavigator, {
  android: MASOMO_ANDROID_STORE_URL,
  ios: MASOMO_IOS_STORE_URL,
  macos: MASOMO_MACOS_STORE_URL,
  windows: MASOMO_WINDOWS_STORE_URL,
});
